module.exports = __webpack_public_path__ + "img/ba.a6d48084.svg";